var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGruppierung({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "segment_24dp_1F1F1F_FILL0_wght300_GRAD0_opsz24",
    className: "st0",
    d: "M13.3529968,22.9329834v-1.5880127h11.6470032v1.5880127h-11.6470032ZM13.3529968,17.7609863v-1.5880127h11.6470032v1.5880127h-11.6470032ZM7,12.5889893v-1.5880127h18v1.5880127H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGruppierung);
export default __webpack_public_path__ + "static/media/Icon_Gruppierung.7d834cbd3ff897d8f59a8be1fc6d5270.svg";
export { ForwardRef as ReactComponent };